export const INTERNAL_LINKS: { [index: string]: string; } = {
    HOME: '/',
    ABOUT: '/about',
    JOIN: '/join-us',
  };
  
  export const EXTERNAL_LINKS: { [index: string]: string; } = {
    DH_MAIN: 'https://dubhacks.co/',
    DH_STATS: 'https://stats.dubhacks.co/',
    DH_NEXT: 'https://next.dubhacks.co/',
    DH_FB: 'https://www.facebook.com/DubHacks.Co/',
    DH_LINKEDIN: 'https://www.linkedin.com/company/dubhacks/',
    DH_INSTAGRAM: 'https://www.instagram.com/dubhacks_/',
    DH_EMAIL: 'mailto:info@dubhacks.co',
    MLH_CODE_OF_CONDUCT: 'https://static.mlh.io/docs/mlh-code-of-conduct.pdf',
    DH_SPONSOR_US: 'https://dubhacks.notion.site/Become-a-DubHacks-Sponsor-bdd6450ddedd471aae6a4edc27082cec',
    DH_JOIN_US: 'https://dubhacks.co/join-us',
    DH_24_APPLY: 'https://forms.gle/p66jmduSJbkX8Ncu9',
    DH_24_JUDGE_MENTOR_FORM: 'https://forms.gle/ACQWwdS3d6uR3R8Q6',
    DH_24_VOLUNTEER_FORM: 'https://docs.google.com/forms/d/e/1FAIpQLScxhmc3myQfFIle6qefeYmWy64hNdMuDsKCauEN4MJHARgkbw/viewform?usp=sf_link',
  };